<template>
  <div v-loading="!loaded">
    <el-card>
      <s-toolbar slot="header" class="clearfix">
        <template slot="left">
          <el-button
            style="float:right"
            type="success"
            plain
            @click="workingYear=null;initArchivedFiles()"
            title="Templates"
          >
            Templates
            <span class="material-icons">file_copy</span>
            <span class="material-icons">folder_special</span>
          </el-button>
        </template>

        <template slot="left">
          <el-button
            :disabled="!!((fileList&&fileList.length)||!workingYear)"
            style="float:right"
            type="warning"
            @click="initArchivedFiles('copy')"
            title="Templates"
          >
            Iniate
            <span class="material-icons">file_copy</span>
            {{theArchive!='templates'?theArchive:''}}
          </el-button>
        </template>
        <el-date-picker
          v-model="workingYear"
          slot="right"
          type="year"
          placeholder="Pick a year"
          @change="initArchivedFiles()"
        ></el-date-picker>
      </s-toolbar>
      <div>
        <!-- <p>{{domain}}</p> -->
        <el-upload
          class="upload-demo"
          drag
          xon-preview="downloadFile"
          :data="prUploadParams"
          action="/assets/components/travel/connector.php"
          xfile-list="files"
          xbefore-upload="udateRecord"
          :on-success="initArchivedFiles"
          multiple
          :show-file-list="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            just drag any file(s) here
            <em>or click here to select one ore more</em>
            to upload
          </div>
          <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
        </el-upload>
        <el-row>
          <el-col :md="12" v-for="(file,idx) in fileList" :key="idx">
            <h4>
              <s-button
                type="danger"
                confirm="Do you want to delete the file?"
                @execute="deleteFile(file)"
              >
                <i class="material-icons">clear</i>
              </s-button>
              <a
                :href="domain+'/assets/files/archive/'+theArchive+'/'+file"
                :ref="'file_'+idx"
                class="dragme"
                :data-downloadurl="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:' +
                  file +
                  ':' +
                  '/assets/files/archive/' +
                  theArchive +
                  '/' +
                  file"
                draggable="true"
              >{{file}}</a>
            </h4>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [commons],
  // name: "drafts-table",
  props: {
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },
    invoiceData: {
      type: Object,
      default: () => {}
    },
    businessId: {
      default: null
    }
  },
  data() {
    return {
      bookingRange: null,
      disabled: true,
      loaded: false,
      fileList: null,
      workingYear: new Date(),
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
      uploadParams: {
        HTTP_MODAUTH: window.Travel.auth,
        ctx: "web",

        action: "gears/archive"
      }
    };
  },
  watch: {
    // "$route.query": {
    //   async handler(val, oldval) {
    //     if (!val || val == oldval) return;
    //     this.loading = true;
    //     this.relRoutes = await api.getModxList("vue_route", {
    //       kind: "package",
    //       // mode: "sap_buisness",
    //       sort: "in",
    //       limit: 0,
    //       start: 0,
    //       tripid: val
    //     });
    //     this.loading = false;
    //   },
    //   immediate: true,
    //   depp:true
    // }
  },
  computed: {
    domain() {
      return window.location.origin;
    },
    theArchive() {
      return this.workingYear ? this.workingYear.getFullYear() : "templates";
    },
    prUploadParams() {
      return {
        ...this.uploadParams,
        do: "upload",
        year: this.theArchive
      };
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration"
    })
  },

  async mounted() {
    this.loaded = true;
    await this.initArchivedFiles();

    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  methods: {
    async deleteFile(file) {
      const { data } = await api.fetchProcessor("gears/archive", {
        ...this.uploadParams,
        do: "delete",
        year: this.theArchive,
        filename: file
      });
      await this.initArchivedFiles();
    },
    async initArchivedFiles(doa) {
      const vm = this;
      // _log_("files/LIST...", this.workingYear.getFullYear(), this.$refs);
      const { data } = await api.fetchProcessor("gears/archive", {
        ...this.uploadParams,
        do: doa == "copy" ? doa : "list",
        year: this.theArchive
      });
      this.fileList = data.object;
      this.$nextTick(() => {
        for (var i = 0; i < this.fileList.length; ++i) {
          const filename = this.fileList[i],
            refFile = this.$refs["file_" + i][0];
          //   :data-downloadurl="'application/pdf:'+file+':'+'/assets/files/archive/'+workingYear+'/'+file"
          // Some forward thinking, utilise the custom data attribute to extend attributes available.

          // files[0].addEventListener(
          //   "dragstart",
          //   function(evt) {
          //     evt.dataTransfer.setData("DownloadURL", fileDetails[0]);
          //   },
          //   false
          // );
          refFile.addEventListener(
            "dragstart",
            function(evt) {
              _log_("files/.D..", evt);
              const fnpath = evt.currentTarget.getAttribute("href"),
                fprts = fnpath.split("/"),
                fnm = fprts[fprts.length - 1],
                dnd =
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:" +
                  fnm +
                  ":" +
                  domain +
                  "/assets/files/archive/" +
                  vm.theArchive +
                  "/" +
                  fnm;
              evt.dataTransfer.setData("DownloadURL", dnd);
              // if (typeof evt.currentTarget.dataset === "undefined")
              //   evt.dataTransfer.setData(
              //     "DownloadURL",
              //     evt.currentTarget.getAttribute("data-downloadurl")
              //   );
              // else
              //   evt.dataTransfer.setData(
              //     "DownloadURL",
              //     evt.currentTarget.dataset.downloadurl
              //   );
            },
            false
          );
        }
      });
    },

    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.TransDraft = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    }
  }
};
</script>
<style >
.dragme {
  background: #2c7ad0;
  color: #fff;
  padding: 10px;
  display: block;
  float: left;
  margin: 10px;

  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

</style>